// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import "./telesales.css";
// import { io } from "socket.io-client";

// function AssignedLeads() {

//   const socketRef = useRef(null);

//   const [search, setSearch] = useState("");
//   const [leads, setLeads] = useState([]);
//   const [filteredLeads, setFilteredLeads] = useState([]);
//   const [users, setUsers] = useState([]);

//   const [form, setForm] = useState({
//     customer_name: "",
//     phone: "",
//     source: "",
//     assign_to: ""
//   });

//   // ✅ HANDLE INPUT
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "phone") {
//       const onlyNumbers = value.replace(/\D/g, "");
//       if (onlyNumbers.length <= 10) {
//         setForm({ ...form, [name]: onlyNumbers });
//       }
//     } else {
//       setForm({ ...form, [name]: value });
//     }
//   };

//   // ✅ FETCH USERS
//   const fetchUsers = async () => {
//     try {
//       const token = localStorage.getItem("token");

//       const res = await axios.get("http://localhost:5000/api/users", {
//         headers: { Authorization: "Bearer " + token }
//       });

//       // ✅ FILTER ONLY REQUIRED ROLES
//       const filteredUsers = res.data.filter(user =>
//         ["sales executive", "sales manager", "boss"].includes(
//           (user.role || "").toLowerCase()
//         )
//       );

//       setUsers(filteredUsers);

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // ✅ FETCH LEADS
//   const fetchLeads = async () => {
//     try {
//       const token = localStorage.getItem("token");

//       const res = await axios.get("http://localhost:5000/api/leads", {
//         headers: { Authorization: "Bearer " + token }
//       });

//       setLeads(res.data);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // ✅ ADD LEAD
//   const addLead = async (e) => {
//     e.preventDefault();

//     if (form.phone.length !== 10) {
//       alert("Phone must be 10 digits");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token");

//       await axios.post(
//         "http://localhost:5000/api/leads",
//         form,
//         {
//           headers: { Authorization: "Bearer " + token }
//         }
//       );

//       fetchLeads();

//       setForm({
//         customer_name: "",
//         phone: "",
//         source: "",
//         assign_to: ""
//       });

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // ✅ FILTER LEADS
//   useEffect(() => {
//     let filtered = leads;

//     if (search) {
//       filtered = filtered.filter((lead) =>
//         lead.customer_name.toLowerCase().includes(search.toLowerCase()) ||
//         lead.phone.includes(search) ||
//         lead.source.toLowerCase().includes(search.toLowerCase())
//       );
//     }

//     setFilteredLeads(filtered);
//   }, [leads, search]);

//   // ✅ SOCKET
//   useEffect(() => {

//     socketRef.current = io("http://localhost:5000");

//     const userId = localStorage.getItem("userId");

//     if (userId) {
//       socketRef.current.emit("join", userId);
//     }

//     socketRef.current.on("new_notification", (data) => {
//       alert(data.message);
//     });

//     return () => {
//       socketRef.current.disconnect();
//     };

//   }, []);

//   // ✅ LOAD DATA
//   useEffect(() => {
//     fetchLeads();
//     fetchUsers();
//   }, []);

//   return (

//     <div className="calllogs-container">

//       {/* 🔍 SEARCH */}
//       <div style={{ marginBottom: "15px" }}>
//         <input
//           type="text"
//           placeholder="Search leads..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//       </div>

//       {/* 📝 FORM */}
//       <form className="call-form" onSubmit={addLead}>

//         <input
//           type="text"
//           name="customer_name"
//           placeholder="Customer Name"
//           value={form.customer_name}
//           onChange={handleChange}
//           required
//         />

//         <input
//           type="tel"
//           name="phone"
//           placeholder="Phone"
//           value={form.phone}
//           onChange={handleChange}
//           maxLength="10"
//           required
//         />

//         <select
//           name="source"
//           value={form.source}
//           onChange={handleChange}
//           required
//         >
//           <option value="">Source</option>
//           <option>Website</option>
//           <option>Facebook</option>
//           <option>Instagram</option>
//           <option>Other</option>
//         </select>

//         {/* ✅ ROLE FILTERED DROPDOWN */}
//         <select
//           name="assign_to"
//           value={form.assign_to}
//           onChange={handleChange}
//           required
//         >
//           <option value="">Assign To</option>

//           {users.map((user) => (
//             <option key={user._id || user.id} value={user._id || user.id}>
//               {user.name} ({user.role})
//             </option>
//           ))}
//         </select>

//         <button type="submit">Assign Lead</button>

//       </form>

//       {/* 📊 TABLE */}
//       <table className="call-table">
//         <thead>
//           <tr>
//             <th>S.No</th>
//             <th>Name</th>
//             <th>Phone</th>
//             <th>Source</th>
//             <th>Assigned To</th>
//             <th>Date</th>
//           </tr>
//         </thead>

//         <tbody>
//           {filteredLeads.map((lead, index) => (
//             <tr key={lead._id || lead.id}>
//               <td>{index + 1}</td>
//               <td>{lead.customer_name}</td>
//               <td>{lead.phone}</td>
//               <td>{lead.source}</td>
//               <td>{lead.assigned_to_name}</td>
//               <td>{new Date(lead.created_at).toLocaleString()}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//     </div>
//   );
// }

// export default AssignedLeads;

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./telesales.css";
import { io } from "socket.io-client";

function AssignedLeads() {

  const socketRef = useRef(null);

  const [search, setSearch] = useState("");
  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);

  // ✅ FETCH ASSIGNED FOLLOWUPS
  const fetchLeads = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        "http://localhost:5000/api/followups/assigned",
        {
          headers: { Authorization: "Bearer " + token }
        }
      );

      setLeads(res.data);

    } catch (err) {
      console.log(err);
    }
  };

  // ✅ SEARCH FILTER
  useEffect(() => {
    let filtered = leads;

    if (search) {
      filtered = filtered.filter((lead) =>
        lead.customer_name.toLowerCase().includes(search.toLowerCase()) ||
        lead.phone.includes(search)
      );
    }

    setFilteredLeads(filtered);
  }, [leads, search]);

  // ✅ SOCKET (optional but working)
  useEffect(() => {

    socketRef.current = io("http://localhost:5000");

    const userId = localStorage.getItem("userId");

    if (userId) {
      socketRef.current.emit("join", userId);
    }

    socketRef.current.on("new_notification", (data) => {
      alert(data.message);
      fetchLeads(); // 🔥 auto refresh
    });

    return () => {
      socketRef.current.disconnect();
    };

  }, []);

  // ✅ LOAD DATA
  useEffect(() => {
    fetchLeads();
  }, []);

  return (

    <div className="calllogs-container">

      {/* 🔍 SEARCH */}
      <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Search assigned followups..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* 📊 TABLE */}
      <table className="call-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Customer Name</th>
            <th>Phone</th>
            <th>Status</th>
            <th>Assigned To</th>
            <th>Date</th>
          </tr>
        </thead>

        <tbody>
          {filteredLeads.map((lead, index) => (
            <tr key={lead.id}>
              <td>{index + 1}</td>
              <td>{lead.customer_name}</td>
              <td>{lead.phone}</td>

              {/* ✅ calls table field */}
              <td>{lead.call_status}</td>

              {/* ✅ joined user name */}
              <td>{lead.assigned_name || "Not Assigned"}</td>

              <td>
                {lead.call_date
                  ? new Date(lead.call_date).toLocaleString()
                  : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}

export default AssignedLeads;